import { useEffect, useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

const RenameCustomTaskModal = ({
  isOpen,
  initialTitle = "",
  onClose,
  onConfirm,
}) => {
  const [title, setTitle] = useState(initialTitle || "Custom Task");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setTitle(initialTitle || "Custom Task");
  }, [initialTitle, isOpen]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    const trimmed = String(title || "").trim();
    if (!trimmed) return;
    setIsSaving(true);
    try {
      await onConfirm(trimmed);
      onClose();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Rename custom task"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-xl shadow-xl border border-gray-200 p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Rename Custom Task
        </h3>

        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          maxLength={60}
          disabled={isSaving}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
          placeholder="Enter custom task name"
          autoFocus
        />

        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 text-sm font-medium hover:bg-gray-300 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isSaving || !String(title || "").trim()}
            className="px-4 py-2 rounded-md bg-black text-white text-sm font-medium hover:bg-gray-800 disabled:opacity-60 inline-flex items-center gap-2"
          >
            {isSaving && <ArrowPathIcon className="h-4 w-4 animate-spin" />}
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameCustomTaskModal;
